'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require('../constants');

var _util = require('./util.js');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class Member
 */
/*!
 * Copyright (c) 2015-2019 Cisco Systems, Inc. See LICENSE file.
 */
var Member = function () {

  /**
   * @param {Object} participant - the locus participant
   * @param {Object} options - optional constructor params
   * @returns {Member}
   * @memberof Member
   */
  function Member(participant) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, Member);
    this.namespace = _constants.MEETINGS;

    this.participant = null;
    this.id = null;
    this.name = null;
    this.isAudioMuted = null;
    this.isVideoMuted = null;
    this.isSelf = null;
    this.isHost = null;
    this.isGuest = null;
    this.isInLobby = null;
    this.isInMeeting = null;
    this.isNotAdmitted = null;
    this.isContentSharing = null;
    this.status = null;
    this.isDevice = null;
    this.isUser = null;
    this.associatedUser = null;
    this.isRecording = null;
    // TODO: more participant types
    this.processParticipant(participant);
    this.processParticipantOptions(participant, options);
  }

  /**
   * set all the participant values extracted directly from locus participant
   * @param {Object} participant the locus participant object
   * @returns {undefined}
   * @memberof Member
   */


  (0, _createClass3.default)(Member, [{
    key: 'processParticipant',
    value: function processParticipant(participant) {
      this.participant = participant;
      if (participant) {
        this.id = _util2.default.extractId(participant);
        this.name = _util2.default.extractName(participant);
        this.isAudioMuted = _util2.default.isAudioMuted(participant);
        this.isVideoMuted = _util2.default.isVideoMuted(participant);
        this.isRecording = _util2.default.isRecording(participant);
        this.isGuest = _util2.default.isGuest(participant);
        this.isUser = _util2.default.isUser(participant);
        this.isDevice = _util2.default.isDevice(participant);
        this.processStatus(participant);
        // must be done last
        this.isNotAdmitted = _util2.default.isNotAdmitted(participant, this.isGuest, this.status);
      }
    }

    /**
     * Use the members options and participant values to set on the member
     * @param {Object} participant the locus participant object
     * @param {Object} options the passed in options, what was set on members
     * @returns {undefined}
     * @memberof Member
     */

  }, {
    key: 'processParticipantOptions',
    value: function processParticipantOptions(participant, options) {
      if (participant && options) {
        this.processIsSelf(participant, options.selfId);
        this.processIsHost(participant, options.hostId);
        this.processIsContentSharing(participant, options.contentSharingId);
      }
    }

    /**
     * set the status on member object
     * @param {Object} participant the locus participant object
     * @returns {undefined}
     * @memberof Member
     */

  }, {
    key: 'processStatus',
    value: function processStatus(participant) {
      this.status = _util2.default.extractStatus(participant);
      switch (this.status) {
        case _constants.IN_LOBBY:
          this.isInLobby = true;
          this.isInMeeting = false;
          break;
        case _constants.IN_MEETING:
          this.isInLobby = false;
          this.isInMeeting = true;
          break;
        case _constants.NOT_IN_MEETING:
          this.isInLobby = false;
          this.isInMeeting = false;
          break;
        default:
          this.isInLobby = false;
          this.isInMeeting = false;
      }
    }

    /**
     * set the isContentSharing on member
     * @param {Boolean} flag
     * @returns {undefined}
     * @memberof Member
     */

  }, {
    key: 'setIsContentSharing',
    value: function setIsContentSharing(flag) {
      this.isContentSharing = flag;
    }

    /**
     * set the isHost on member
     * @param {Boolean} flag
     * @returns {undefined}
     * @memberof Member
     */

  }, {
    key: 'setIsHost',
    value: function setIsHost(flag) {
      this.isHost = flag;
    }

    /**
     * set the isSelf on member
     * @param {Boolean} flag
     * @returns {undefined}
     * @memberof Member
     */

  }, {
    key: 'setIsSelf',
    value: function setIsSelf(flag) {
      this.isSelf = flag;
    }

    /**
     * determine if this member is content sharing
     * @param {Object} participant
     * @param {String} sharingId
     * @returns {undefined}
     * @memberof Member
     */

  }, {
    key: 'processIsContentSharing',
    value: function processIsContentSharing(participant, sharingId) {
      if (_util2.default.isUser(participant)) {
        this.isContentSharing = _util2.default.isSame(participant, sharingId);
      } else if (_util2.default.isDevice(participant)) {
        this.isContentSharing = _util2.default.isAssociatedSame(participant, sharingId);
      }
    }

    /**
     * determine if this member is the self
     * @param {Object} participant
     * @param {String} selfId
     * @returns {undefined}
     * @memberof Member
     */

  }, {
    key: 'processIsSelf',
    value: function processIsSelf(participant, selfId) {
      if (_util2.default.isUser(participant)) {
        this.isSelf = _util2.default.isSame(participant, selfId);
      } else if (_util2.default.isDevice(participant)) {
        this.isSelf = _util2.default.isAssociatedSame(participant, selfId);
        this.associatedUser = selfId;
      }
    }

    /**
     * determine if this member is the host
     * @param {Object} participant
     * @param {String} hostId
     * @returns {undefined}
     * @memberof Member
     */

  }, {
    key: 'processIsHost',
    value: function processIsHost(participant, hostId) {
      if (_util2.default.isUser(participant)) {
        this.isHost = _util2.default.isSame(participant, hostId);
      } else if (_util2.default.isDevice(participant)) {
        this.isHost = _util2.default.isAssociatedSame(participant, hostId);
      }
    }
  }]);
  return Member;
}();

exports.default = Member;
//# sourceMappingURL=index.js.map
